// extracted by mini-css-extract-plugin
export default {"element":"Ticker-module--element--d0487","container":"Ticker-module--container--34b60","link":"Ticker-module--link--1445d"};